export default "__VITE_ASSET__BqYFUd6b__"